import React, {Component} from 'react';
import _ from 'lodash';
import I18n from 'app/common/i18n';

import FilerSection from './FilterSection';
import StudentList from './StudentList';
import ZeroStateCandidateSelectionIcon from 'app/assets/search-icon.svg';

export default class CandidatesView extends Component {

  renderPlaceholder() {
    let {candidates: {searched}} = this.props;

    if(searched) {
      return (
        <div className='center mt3'>
          {I18n.t('candidates.no_results')}
        </div>
      );
    }
    return (
      <div className='center mt3'>
        <div>
          <ZeroStateCandidateSelectionIcon className='svg-icon svg-5x'/>
        </div>
        <div className='mt1'>
          <div>{I18n.t('candidates.list_placeholder_1')}</div>
          <div className='mt1'>{I18n.t('candidates.list_placeholder_2')}</div>
        </div>
      </div>
      );
  }

  getRequestQuery(query, assessmentId, index) {
    if (index === 0)
      return `assessmentId=${assessmentId}`;
    return `${query}&assessmentId=${assessmentId}`;
  }

  fetchReport(student) {
    let {candidates: {filter}} = this.props;
    let assessmentIds = _.map(filter.skills, 'id');
      let query = '';
      assessmentIds.map((assessmentId, index) => {
      query = this.getRequestQuery(query, assessmentId, index);
    });
    window.open(`${window.location.hash}/reports/${student.studentId}/details/${query}?carats=${student.carats}`);
  }

	render() {
    let {candidates: {searchText,
         candidates =[],
         isSelectedStudentsView,
         filter},
         sessions: {assessments},
         updateFilter,
         fetchCandidates,
         fetchReport
       } = this.props;

    let shouldRenderList=candidates.length!=0
		return (
			<div className='m3'>
				<FilerSection
          filter={filter}
          assessments={assessments}
          updateFilter={updateFilter}
          fetchCandidates={fetchCandidates}/>
				{
          shouldRenderList ?
          <StudentList
            selectedStudents={[]}
            searchText={searchText}
            studentList={candidates}
            isSelectedStudentsView={isSelectedStudentsView}
            fetchReport={(student) => this.fetchReport(student)}/> :
          this.renderPlaceholder()
        }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/candidates/index.js